// @flow

export const nextPlanSelector = (state: Object): Object => state.nextPlan;

export const hasNextPlanSelector = (state: Object): boolean => !!state.nextPlan;

export const nextPlanOptionsSelector = (state: Object): Object[] => state.nextPlan.options || [];

export const nextPlanCharacteristicsSelector = (state: Object): Object => state.nextPlan.planCharacteristics;

export const nextPlanUuidSelector = (state: Object): string => state.nextPlan.uuid;

export const nextPlanVouchersSelector = (state: Object): string => state.nextPlan.bonuses || [];
